
precision highp float;
precision highp sampler2D;

// Lower bound of |field| (same units as fieldScalar); at or below → base PARTICLE_COLOR (ParticleLayer fieldColorMin).
uniform float fieldColorMin;
// Upper bound for full PARTICLE_FAST_COLOR; between min/max → linear mix (ParticleLayer fieldColorMax).
uniform float fieldColorMax;

// Written fragment color.
out vec4 fragColor;

// Screen-space motion approx px/s between RTT frames;
in float speed;
// Decoded field magnitude at particle: rttScalar R × PARTICLE_FIELD_MAGNITUDE_MAX.
in float fieldScalar;

void main() {
  // calculate the uv coordinates of the pixel
  vec2 uv = vec2( gl_PointCoord.x -0.5, 1.0 - gl_PointCoord.y-0.5 );

  // calculate the distance from the center of the pixel
  float dFromCenter = sqrt(uv.x * uv.x + uv.y * uv.y);

  if (DRAW_AS_LINES != 1) {
    // cull if pixel is greater than half the radius distance from the center
    if(dFromCenter > 0.5){
      discard;
      return;
    }
  //   // cull if particle speed is too low
    if (speed < 0.0001) {
      discard;
      return;
    }
  }


/**
 * Calculates the particle color based on the field scalar.
 * TODO: this if / else is a bit iffy on the GPU, look at switching to inbuilt GLSL funcs if at all possible.
 */
  float fieldT;
  if (fieldColorMax <= fieldColorMin) {
    fieldT = fieldScalar >= fieldColorMax ? 1.0 : 0.0;
  } else if (fieldScalar <= fieldColorMin) {
    fieldT = 0.0;
  } else if (fieldScalar >= fieldColorMax) {
    fieldT = 1.0;
  } else {
    fieldT = (fieldScalar - fieldColorMin) / (fieldColorMax - fieldColorMin);
  }

  fragColor = mix(PARTICLE_COLOR, PARTICLE_FAST_COLOR, fieldT);

  float motionFade = smoothstep(0.05, 0.1, speed / PARTICLE_MAX_SPEED);
  float windFade = smoothstep(0.0, 0.02, fieldScalar);
  float opacityFactor = max(motionFade, windFade);
  fragColor.a *= opacityFactor;
}
